/* unplugin-vue-components disabled */import script from "./PoweredBy.vue?vue&type=script&setup=true&lang=js"
export * from "./PoweredBy.vue?vue&type=script&setup=true&lang=js"

import "./PoweredBy.vue?vue&type=style&index=0&id=70564a72&lang=scss"

const __exports__ = script;

export default __exports__